module.exports = __webpack_public_path__ + "static/img/btn@2x.f9938b7e.png";